export default "__VITE_ASSET__Cfn9HNnE__"